module.exports = __webpack_public_path__ + "img/dxctj-3000.7544b4cf.jpg";